import axios from "axios"

export const deleteGruppo = (id: number) => {
  return new Promise((resolve, reject) => {
    axios
      .delete(`/api/Gruppo/${id}`)
      .then(() => {
        resolve(true)
      })
      .catch((error) => {
        reject(error.response.data.response)
      })
  })
}
export default deleteGruppo
